import type { Edge, Node } from "@xyflow/react";
import type { BuildTypeGraphParams, ExplodeFlow, ExplodeNodeData } from "../types";
import { NodeKind, NodeRole } from "../types";

const NODE_WIDTH = 240;
const COLUMN_GAP = 44;
const ROOT_Y = 0;
const ROW_Y = 200;

export const buildTypeGraph = ({ types, field, rootLabel }: BuildTypeGraphParams): ExplodeFlow => {
    const sorted = [...types].sort(
        (left, right) => right.count - left.count || left.value.localeCompare(right.value),
    );
    const columnStep = NODE_WIDTH + COLUMN_GAP;
    const totalWidth = Math.max(sorted.length * columnStep - COLUMN_GAP, NODE_WIDTH);

    const typeNodes = sorted.map<Node<ExplodeNodeData>>((bucket, position) => ({
        id: `type-${position}`,
        type: NodeKind.BUCKET,
        position: { x: position * columnStep, y: ROW_Y },
        data: {
            label: bucket.value,
            count: bucket.count,
            role: NodeRole.GROUP,
            selection: [{ field, value: bucket.value }],
        },
    }));

    const rootNode: Node<ExplodeNodeData> = {
        id: "root",
        type: NodeKind.BUCKET,
        position: { x: (totalWidth - NODE_WIDTH) / 2, y: ROOT_Y },
        data: { label: rootLabel, role: NodeRole.ROOT, selection: [] },
    };

    const edges = sorted.map<Edge>((_, position) => ({
        id: `e-root-${position}`,
        source: "root",
        target: `type-${position}`,
        type: "step",
    }));

    return { nodes: [rootNode, ...typeNodes], edges };
};
